export default "__VITE_ASSET__D68S972g__"